/**
 * Please note:
 *
 * Translations are provided as an illustration only and are
 * not guaranteed to be accurate or error-free.
 *
 * They are designed to show developers where to store their
 * chosen phrase or spelling variant in the target language.
 */

export const AG_CHARTS_LOCALE_HR_HR: Record<string, string> = {
    ariaAnnounceChart: 'grafikon, ${seriesCount}[number] serija',
    ariaAnnounceFlowProportionLink: 'veza ${index} od ${count}, od ${from} do ${to}, ${sizeName} ${size}',
    ariaAnnounceFlowProportionNode: 'čvor ${index} od ${count}, ${description}',
    ariaAnnounceGaugeChart: 'mjerna ljestvica, ${caption}',
    ariaAnnounceHierarchyChart: 'hijerarhijski grafikon, ${caption}',
    ariaAnnounceHierarchyDatum: 'razina ${level}[number], ${count}[number] djece, ${description}',
    ariaAnnounceHoverDatum: '${datum}',
    ariaDescriptionLegendItem: 'Pritisnite razmaknicu ili Enter za uključivanje/isključivanje vidljivosti',
    ariaLabelAddHorizontalLine: 'Dodaj vodoravnu liniju',
    ariaLabelAnnotationOptionsToolbar: 'Opcije komentara',
    ariaLabelAnnotationSettingsDialog: 'Postavke bilješki',
    ariaLabelColorPicker: 'Birač boja',
    ariaLabelFinancialCharts: 'Financijski grafikoni',
    ariaLabelLegend: 'Legenda',
    ariaLabelLegendItem: '${label}, Legenda stavka ${index}[number] od ${count}[number]',
    ariaLabelLegendItemUnknown: 'Nepoznata stavka legende',
    ariaLabelLegendPageNext: 'Sljedeća stranica legende',
    ariaLabelLegendPagePrevious: 'Prethodna stranica legende',
    ariaLabelLegendPagination: 'Paginacija legende',
    ariaLabelNavigator: 'Navigator',
    ariaLabelNavigatorMaximum: 'Maksimum',
    ariaLabelNavigatorMinimum: 'Minimum',
    ariaLabelNavigatorRange: 'Raspon',
    ariaLabelRangesToolbar: 'Rasponi',
    ariaLabelSettingsTabBar: 'Postavke',
    ariaLabelZoomToolbar: 'Zum',
    ariaValuePanRange: '${min}[percent0to2dp] do ${max}[percent0to2dp]',
    contextMenuDownload: 'Preuzmi',
    contextMenuPanToCursor: 'Pomakni ovdje',
    contextMenuToggleOtherSeries: 'Prebaci ostale serije',
    contextMenuToggleSeriesVisibility: 'Prebaci vidljivost',
    contextMenuZoomToCursor: 'Povećaj ovdje',
    dialogHeaderChannel: 'Kanal',
    dialogHeaderDatePriceRange: 'Datum i cijena',
    dialogHeaderDateRange: 'Raspon datuma',
    dialogHeaderFibonacciRange: 'Fib Povlačenje',
    dialogHeaderLine: 'Linija',
    dialogHeaderPriceRange: 'Raspon cijena',
    dialogHeaderText: 'Tekst',
    dialogInputAlign: 'Poravnaj',
    dialogInputColorPicker: 'Boja',
    dialogInputColorPickerAltText: 'Boja teksta',
    dialogInputExtendAbove: 'Proširi iznad',
    dialogInputExtendBelow: 'Proširi ispod',
    dialogInputExtendChannelEnd: 'Proširi kraj kanala',
    dialogInputExtendChannelStart: 'Produži početak kanala',
    dialogInputExtendLeft: 'Proširi lijevo',
    dialogInputExtendLineEnd: 'Produži kraj linije',
    dialogInputExtendLineStart: 'Produži početak linije',
    dialogInputExtendRight: 'Proširi desno',
    dialogInputFibonacciBands: 'Pojasevi',
    dialogInputFibonacciBandsAltText: 'Fibonacci Pojasevi',
    dialogInputFillColorPicker: 'Ispuna',
    dialogInputFillColorPickerAltText: 'Ispuni boju',
    dialogInputFontSize: 'Veličina',
    dialogInputFontSizeAltText: 'Veličina fonta',
    dialogInputLineStyle: 'Crtkano',
    dialogInputPosition: 'Pozicija',
    dialogInputReverse: 'Obrnuto',
    dialogInputShowFill: 'Prikaži ispunu',
    dialogInputStrokeWidth: 'Debljina',
    dialogInputStrokeWidthAltText: 'Debljina crte',
    iconAltTextAlignCenter: 'Poravnaj u sredinu',
    iconAltTextAlignLeft: 'Lijevo',
    iconAltTextAlignRight: 'Desno',
    iconAltTextClose: 'Zatvori',
    iconAltTextLineStyleDashed: 'Dugih crtica',
    iconAltTextLineStyleDotted: 'Kratko-crtkano',
    iconAltTextLineStyleSolid: 'Puna',
    iconAltTextPositionBottom: 'Dno',
    iconAltTextPositionCenter: 'Središte',
    iconAltTextPositionTop: 'Vrh',
    inputTextareaPlaceholder: 'Dodaj tekst',
    measurerDateRangeBars: '${value}[number] trake',
    measurerPriceRangePercent: '${value}[percent]',
    measurerPriceRangeValue: '${value}[number]',
    measurerVolume: 'Vol ${value}',
    overlayLoadingData: 'Učitavanje podataka...',
    overlayNoData: 'Nema dostupnih podataka za prikaz',
    overlayNoVisibleSeries: 'Nema vidljivih serija',
    overlayUnsupportedBrowser: 'Nekompatibilna verzija preglednika. Molimo ažurirajte svoj preglednik.',
    seriesHistogramTooltipCount: '${yName} (broj)',
    seriesHistogramTooltipFrequency: 'Frekvencija',
    seriesHistogramTooltipMean: '${yName} (prosjek)',
    seriesHistogramTooltipSum: '${yName} (zbroj)',
    toolbarAnnotationsArrow: 'Strelica',
    toolbarAnnotationsArrowDown: 'Strelica dolje',
    toolbarAnnotationsArrowUp: 'Strelica gore',
    toolbarAnnotationsCallout: 'Poziv',
    toolbarAnnotationsClearAll: 'Očisti sve',
    toolbarAnnotationsComment: 'Komentar',
    toolbarAnnotationsDatePriceRange: 'Datum i cijena',
    toolbarAnnotationsDateRange: 'Raspon datuma',
    toolbarAnnotationsDelete: 'Izbriši',
    toolbarAnnotationsDisjointChannel: 'Diskretni kanal',
    toolbarAnnotationsDragHandle: 'Povuci alatnu traku',
    toolbarAnnotationsFibonacciAnnotations: 'Fibonacci',
    toolbarAnnotationsFibonacciRetracement: 'Fib Povlačenje',
    toolbarAnnotationsFibonacciRetracementTrendBased: 'Fib temeljen na trendu',
    toolbarAnnotationsFillColor: 'Boja ispune',
    toolbarAnnotationsHorizontalLine: 'Horizontalna linija',
    toolbarAnnotationsLineAnnotations: 'Linije trendova',
    toolbarAnnotationsLineColor: 'Boja linije',
    toolbarAnnotationsLineStrokeWidth: 'Širina crte poteza',
    toolbarAnnotationsLineStyle: 'Stil crte',
    toolbarAnnotationsLock: 'Zaključaj',
    toolbarAnnotationsMeasurerAnnotations: 'Mjerne jedinice',
    toolbarAnnotationsNote: 'Bilješka',
    toolbarAnnotationsParallelChannel: 'Paralelni kanal',
    toolbarAnnotationsPriceRange: 'Raspon cijena',
    toolbarAnnotationsQuickDatePriceRange: 'Mjera',
    toolbarAnnotationsSettings: 'Postavke',
    toolbarAnnotationsShapeAnnotations: 'Strelice',
    toolbarAnnotationsText: 'Tekst',
    toolbarAnnotationsTextAnnotations: 'Tekstualne Anotacije',
    toolbarAnnotationsTextColor: 'Boja teksta',
    toolbarAnnotationsTextSize: 'Veličina teksta',
    toolbarAnnotationsTrendLine: 'Trend linija',
    toolbarAnnotationsUnlock: 'Otključaj',
    toolbarAnnotationsVerticalLine: 'Vertikalna linija',
    toolbarRange1Month: '1M',
    toolbarRange1MonthAria: '1 mjesec',
    toolbarRange1Year: '1G',
    toolbarRange1YearAria: '1 godina',
    toolbarRange3Months: '3M',
    toolbarRange3MonthsAria: '3 mjeseca',
    toolbarRange6Months: '6M',
    toolbarRange6MonthsAria: '6 mjeseci',
    toolbarRangeAll: 'Sve',
    toolbarRangeAllAria: 'Sve',
    toolbarRangeYearToDate: 'Godina do danas',
    toolbarRangeYearToDateAria: 'Godina do danas',
    toolbarSeriesTypeCandles: 'Svijeće',
    toolbarSeriesTypeDropdown: 'Vrsta grafikona',
    toolbarSeriesTypeHighLow: 'Visoko Nisko',
    toolbarSeriesTypeHLC: 'HLC',
    toolbarSeriesTypeHollowCandles: 'Šuplje Svijeće',
    toolbarSeriesTypeLine: 'Linija',
    toolbarSeriesTypeLineWithMarkers: 'Linija s oznakama',
    toolbarSeriesTypeOHLC: 'OHLC',
    toolbarSeriesTypeStepLine: 'Korak Linija',
    toolbarZoomPanEnd: 'Pomicanje na kraj',
    toolbarZoomPanLeft: 'Pomičite lijevo',
    toolbarZoomPanRight: 'Pomakni desno',
    toolbarZoomPanStart: 'Pomakni na početak',
    toolbarZoomReset: 'Resetiraj povećanje',
    toolbarZoomZoomIn: 'Povećaj',
    toolbarZoomZoomOut: 'Umanji',
    tooltipPaginationStatus: '${index}[number] od ${count}[number]',
};
